import { NO_HOST_FLAG } from '#components/patterns/entity-select/host/SelectHost.queries.ts';
import type { Route } from '#dn-types/route.ts';
import { ALL_ROLES_FLAG } from '#screens/routes/form/firewall-rule/CIDRFirewallRuleForm.queries.ts';
import type { RouteFormData } from '#screens/routes/form/route-form-schema.ts';

export function mapRouteToForm(route: Route): RouteFormData {
  const routableCIDRs = Object.entries(route.routableCIDRs).map(([cidr, { install }]) => ({ cidr, install }));

  return {
    name: route.name,
    description: route.description,
    routerHostID: route.routerHostID ?? NO_HOST_FLAG,
    routableCIDRs,
    firewallRules: mapFirewallRulesToFormData(route.firewallRules),
  };
}

export function mapFirewallRulesToFormData(firewallRules: Route['firewallRules']): RouteFormData['firewallRules'] {
  return firewallRules.map((rule) => ({
    localCIDR: rule.localCIDR,
    portRange: rule.portRange,
    description: rule.description,
    protocol: rule.protocol,
    allowedRoleID: rule.allowedRoleID ?? ALL_ROLES_FLAG,
    tags: rule.allowedTags ?? [],
  }));
}
